import { connect } from 'react-redux';
import ActionPanel from '../../components/ActionPanel';

const mapStateToProps = state => ({
  ...state.actionPanel,
});

export default connect(mapStateToProps)(ActionPanel);
